'use strict';

module.exports = {
  overrideWithEnginePrice: 'override-with-engine-price',
  overrideWithIntentionPrice: 'override-with-intention-price',
  removeAllOverrides: 'remove-all-overrides',
  overrideWithCostPriceDelta: 'override-with-cost-price-delta',
  overrideWithTransferPriceDelta: 'override-with-transfer-price-delta',
  overrideWithPurchasePriceDelta: 'override-with-purchase-price-delta',
};
